import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

i18n
  // 使用 Backend 加载翻译文件
  .use(Backend)
  // 检测用户语言
  .use(LanguageDetector)
  // 将 i18n 实例传递给 react-i18next
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',
    ns: [
      'common',
      'auth',
      'dashboard',
      'delivery',
      'orders',
      'credits',
      'users',
      'providers',
      'privacy-policy',
      'general-conditions',
      'invoices',
      'providers',
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // 不需要React转义
    },
    detection: {
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['cookie', 'localStorage'],
    },
    backend: {
      // 翻译文件的路径
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  })

export default i18n
